import { Add, GridView } from "@mui/icons-material";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { useLocation } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const AddersCategories = () => {
    const location = useLocation();
    const { group_id } = useParams();

    const path = location.pathname.split("/")[2];
    const { category_childrens, isSuccess, isLoading, isError, errors } = useSelector(
        (state) => state.adders_categories
    );
    const AllCatChildrensVal = category_childrens?.data || [];
    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    
                    <span>
                    <Link mr={2} to="/dashboard/adders-categories">
                        Adders Groups
                    </Link>
                    </span>
                    {/* <span> Adders Groups </span> */}
                    {group_id && AllCatChildrensVal?.name && (
                        <span>
                            {" "} > {" "}
                            {AllCatChildrensVal?.name} {" "} ({AllCatChildrensVal?.group_children?.length})
                        </span>
                    )}
                </div>

                <Link to="/dashboard/adders-categories/create-group">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default AddersCategories;
